import { useCallback } from 'react';
import { useAuth } from '@hooks/useAuth';
import { combineUserName } from '@helpers/combineUserName';
import UserAvatarLetters from '@helpers/userAvatarLetters';
import { useAssetViewerState } from '@hooks/useAssetViewerState';

export default function useUserPicture() {
  const { user } = useAuth();
  const { commentsList } = useAssetViewerState();

  const setMyPicture = useCallback(() => {
    if (!user) return { name: '', userId: '', email: '', picture: null };
    const { id, email } = user;
    const alt = UserAvatarLetters(combineUserName(user));
    return { name: alt, email, userId: id, picture: user.pictureUrl };
  }, [user]);

  const getUserPicture = useCallback(
    (commentId: string) => {
      const comment = commentsList.find((it) => it.id === commentId);
      if (!comment?.user) {
        return { name: '', email: '', userId: '', picture: null };
      }
      const { email, id } = comment.user;
      const alt = UserAvatarLetters(combineUserName(comment.user));
      return {
        name: alt,
        email,
        userId: id,
        picture: comment.user.picture?.url ?? null
      };
    },
    [commentsList]
  );

  return { setMyPicture, getUserPicture };
}
